<template>
    <div class="plugin__entry">
        <div class="entry__image">
            <div class="fake__image"></div>
        </div>
        <div class="entry__title">
            <h3>&nbsp;</h3>
        </div>
        <div class="entry__meta">
            <span class="info">
                <span class="info--technology">&nbsp;</span>
                •
                <span class="info--technology">&nbsp;</span>
            </span>
            <p class="description">&nbsp;</p>
            <div class="rating">
                 <span>
                    <svg v-for="star in 5" :key="star" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 260 245"><path  fill="#F4F4F4" d="m55,237 74-228 74,228L9,96h240"/></svg>
                </span>
                <span class="rating__counter">&nbsp;</span>
            </div>
            <div class="creator">&nbsp;</div>
        </div>
        <div v-if="highlight" class="highlight">
            <img src="https://dummyimage.com/22x20/E73246/E73246" >
        </div>
    </div>
</template>

<script>
export default {
    props: {
        highlight: {
            type: Boolean,
            required: false,
        }
    },
}
</script>

<style scoped lang="scss">
    .fake__image,
    h3,
    .info--technology,
    .rating__counter,
    .description,
    .creator{
        background-color: #F4F4F4;
        animation: pulse 2s infinite;
    }

    @keyframes pulse {
	0% {
		background-color: #F4F4F4;
	}

	70% {
		background-color: #EFEFEF;
	}

	100% {
		background-color: #F4F4F4;
	}
}
    .fake__image{
        width: 128px;
        height: 128px;
    }
    .info--technology{
        width: 50px;
        display: inline-block;

    }
    .rating__counter{
        width: 50px;
    }
    .description{
        height: 100px;
    }
    .info{
        color: #F4F4F4 !important;
    }
    .creator{
        width: 100px;
    }

    .plugin__entry{
        padding: 25px;
        background-color: #FFFFFF;
        border: 1px solid #DEDEDE;
        box-sizing: border-box;
        position: relative;
    }

    .entry__image{
        padding-bottom: 25px;
    }
    .entry__title h3{
        font-weight: normal;
        margin: 0;
        font-size: 23px;
        line-height: 28px;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-bottom: 10px;
    }
    .entry__title h3 a{
        text-decoration: none;
        color: #000000;
    }

    .entry__meta .info{
        font-size: 14px;
        line-height: 20px;
        color: #575C61;
    }

    .entry__meta .description{
        margin: 0;
        margin-top: 20px;
        margin-bottom: 15px;
        font-size: 16px;
        line-height: 23px;
        color: #575C61;
    }

    .rating{
        padding-bottom: 15px;
    }

    .creator{
        font-size: 14px;
        line-height: 20px;
        color: #000A12;
    }
    .creator .creator--link{
        color: #E73246;
    }
    .rating__counter{
        font-size: 14px;
        line-height: 20px;
        margin-left: 5px;
        display: inline-block;
        vertical-align: top;
        color: #575C61;
    }
    .entry__image img{
        width: 100%;
        height: auto;
        max-width: 128px;
        max-height: 128px;
    }
    .highlight{
        position: absolute;
        top: 25px;
        right: 25px;
    }
</style>